import { CMS_Content_Modules_Enum } from '../modules/types';
import { CMS_Content_Module } from '../types';
import { ContentBlock } from './content-block';
import { LoadingSpinner } from '@cue/atoms';
import { useUser } from '@project/hooks/use-user';
import { useEffect, useState } from 'react';

interface IContentSections {
  data?: CMS_Content_Module[];
  exclude?: CMS_Content_Modules_Enum[];
}

export const ContentSections = ({ data, exclude }: IContentSections) => {
  const [loading, setLoading] = useState(true);
  const [isRegistered, setIsRegistered] = useState(false);
  const { user, loading: userLoading } = useUser();

  useEffect(() => {
    if (!userLoading) {
      setIsRegistered(user !== false);
      setLoading(false);
    }
  }, [user, userLoading]);

  let content = data;
  if (exclude) content = content?.filter((elem) => !exclude.includes(elem.type));

  if (loading) return <LoadingSpinner />;
  return (
    <>
      {content?.map((contentBlock, i) => {
        const full_width = contentBlock?.type === 'content_module_fullscreen_slogan';
        return (
          <div
            key={i}
            className={`cue-project-content-container-element ${contentBlock?.type} ${
              full_width ? 'full-width' : ''
            }`}>
            <ContentBlock
              type={contentBlock.type}
              data={contentBlock.data}
              options={contentBlock.options}
              key={`contentBlock-${i}`}
              isRegistered={isRegistered}
            />
          </div>
        );
      })}
    </>
  );
};
